import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const MERCHANT_CUSTOMER_ENDPOINT = '/v1.0/customer'
const MERCHANT_SUPPLIER_ENDPOINT = '/v1.0/sc/suppliers'
const MERCHANT_CUSTOMER_TRANSACTION_ENDPOINT = '/v1.0/transaction'
const MERCHANT_SUPPLIER_TRANSACTION_ENDPOINT = '/v1.0/sc/transactions'
const TRANSACTION_IMAGE = '/v1.0/new/transaction-images'
const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/ledger`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const patchCustomer = (customerId: string, payload: object) => {
  return api.putRequest(`${MERCHANT_CUSTOMER_ENDPOINT}/${customerId}`, payload)
}

const LIST_DUES_INFO_ENDPOINT = '/v1.0/new/ListDuesInfo'
export const listCustomerDuesInfo = (businessId: string) => {
  return api.postRequest(LIST_DUES_INFO_ENDPOINT, { seller_id: businessId })
}

export const updateCustomerDueDate = (customerId: string, dueDateInSeconds: number | null) => {
  const payload =
    dueDateInSeconds === null
      ? { delete_due_custom_date: true }
      : { due_custom_date: dueDateInSeconds, update_due_custom_date: true }
  return patchCustomer(customerId, payload)
}

export const addSupplier = (name: string, mobile?: string) => {
  const sendObject = mobile ? { mobile, name } : { name }
  return api.postRequest(MERCHANT_SUPPLIER_ENDPOINT, sendObject)
}

export const deleteCustomer = (customerId: string) => {
  return api.deleteRequest(`${MERCHANT_CUSTOMER_ENDPOINT}/${customerId}`)
}

export const addCustomer = (name: string, mobile?: string) => {
  const sendObject = mobile ? { mobile, description: name } : { description: name }
  return api.postRequest(MERCHANT_CUSTOMER_ENDPOINT, sendObject)
}

export const addCustomerDetails = (payload: {
  name: string
  mobile?: string
  customerCode?: string
  gstNumber?: string
  address?: string
}) => {
  const requestPayload = {
    description: payload.name,
    ...(payload?.mobile && { mobile: payload.mobile }),
    ...(payload?.customerCode && { customer_code: payload.customerCode }),
    ...(payload?.gstNumber && { gst_number: payload.gstNumber }),
    ...(payload?.address && { address: payload.address })
  }

  return api.postRequest(MERCHANT_CUSTOMER_ENDPOINT, requestPayload)
}

export const getCustomerData = (id: string) => {
  return api.getRequest(`${MERCHANT_CUSTOMER_ENDPOINT}/${id}`, {})
}
export const getSuppliersList = () => {
  return api.getRequest(MERCHANT_SUPPLIER_ENDPOINT, {})
}

export const deleteSupplier = (supplierId: string) => {
  return api.deleteRequest(`${MERCHANT_SUPPLIER_ENDPOINT}/${supplierId}`)
}

export const patchSupplier = (supplierId: string, payload: object) => {
  return api.patchRequest(`${MERCHANT_SUPPLIER_ENDPOINT}/${supplierId}`, payload)
}

export const createCustomerTransaction = (payload: object) => {
  return api.postRequest(MERCHANT_CUSTOMER_TRANSACTION_ENDPOINT, payload)
}

export const createSupplierTransaction = (supplierId: string, payload: object) => {
  return api.postRequest(`${MERCHANT_SUPPLIER_ENDPOINT}/${supplierId}/transactions`, payload)
}

export const deleteTransactionForSupplier = (tranasactionId: string) => {
  return api.deleteRequest(`${MERCHANT_SUPPLIER_TRANSACTION_ENDPOINT}/${tranasactionId}`)
}

export const deleteTransactionForCustomer = (transactionId: string) => {
  return api.deleteRequest(`${MERCHANT_CUSTOMER_TRANSACTION_ENDPOINT}/${transactionId}`)
}

export const getTransactionData = (id: string) => {
  return api.getRequest(`${MERCHANT_CUSTOMER_TRANSACTION_ENDPOINT}/${id}`, {})
}

export const addTransactionImage = (payload: any) => {
  return api.postRequest(TRANSACTION_IMAGE, payload)
}

export const removeTransactionImage = (payload: string) => {
  return api.deleteRequest(`${TRANSACTION_IMAGE}/${payload}`)
}

export const CustomerAndSupplierApi = {
  patchCustomer,
  listCustomerDuesInfo,
  updateCustomerDueDate,
  addCustomer,
  deleteCustomer,
  getCustomerData,
  deleteSupplier,
  patchSupplier,
  addSupplier,
  getSuppliersList,
  createSupplierTransaction,
  deleteTransactionForSupplier,
  deleteTransactionForCustomer,
  createCustomerTransaction,
  getTransactionData,
  addTransactionImage,
  removeTransactionImage
}
